// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgBellOff24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.21968 2.08981C4.96454 1.76351 4.49318 1.70582 4.16688 1.96096C3.84057 2.21611 3.78289 2.68746 4.03803 3.01377L6.31122 5.92097C5.48611 7.06958 5.00025 8.47829 5.00025 10.0005L4.99986 14.3845L2.60279 18.0735C2.53953 18.1708 2.50586 18.2844 2.50586 18.4005C2.50586 18.7318 2.77449 19.0005 3.10586 19.0005L8.75985 19.0021C8.8883 20.6795 10.29 22.0005 12.0002 22.0005C13.7108 22.0005 15.1128 20.6789 15.2407 19.0011L16.5387 19.001L18.8135 21.9103C19.0687 22.2366 19.54 22.2942 19.8663 22.0391C20.1926 21.784 20.2503 21.3126 19.9952 20.9863L18.4426 19.0008L20.9275 19.0005C21.2589 19.0005 21.5275 18.7318 21.5275 18.4005L21.5218 18.3179C21.5104 18.2361 21.4823 18.1573 21.4388 18.0864L18.9999 14.1165L19.0002 10.0005C19.0002 6.13448 15.8662 3.00048 12.0002 3.00048C10.2051 3.00048 8.5678 3.67621 7.3288 4.78718L5.21968 2.08981ZM7.28542 7.16688C6.78697 7.99449 6.50025 8.96406 6.50025 10.0006L6.49982 14.8291L4.76286 17.5005H15.3655L7.28542 7.16688ZM17.2696 17.5005L8.25544 5.97226C9.23733 5.05903 10.5536 4.50048 12.0002 4.50048C15.0378 4.50048 17.5002 6.96291 17.5002 10.0005L17.4998 14.5404L19.3179 17.5005H17.2696ZM10.2683 19.0026L13.7324 19.0016C13.6106 19.8491 12.8815 20.5005 12.0002 20.5005C11.1194 20.5005 10.3905 19.8496 10.2683 19.0026Z"
				/>
			</Svg>
		);
	}
);
SvgBellOff24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgBellOff24;
